import React from "react";

import "./verticalLine.scss";

const VerticalLine = () => {
  return <div className="vertical-line"></div>;
};

export default VerticalLine;
